/** Reject redirect URLs that would navigate away from the current origin. */
export const isSafeRedirectUrl = (url: string): boolean => {
  if (url === 'undefined') {
    return false;
  }

  try {
    const parsed = new URL(url, window.location.origin);

    return parsed.origin === window.location.origin;
  } catch {
    return false;
  }
};
